/**
 * Central icon registry — edit icon names here for sidebar, dashboard, and modules.
 *
 * Usage in moduleRegistry:  icon: 'users'
 * Usage in components:       <AppIcon name="users" />
 *
 * Browse icons: https://phosphoricons.com
 */
import {
  BugBeetle,
  Buildings,
  ChartBar,
  ChartLine,
  Check,
  Circle,
  Clipboard,
  Coins,
  CreditCard,
  Crown,
  FileText,
  Gear,
  Gift,
  GitFork,
  GraduationCap,
  House,
  Image,
  Intersect,
  Lightbulb,
  MegaphoneSimple,
  Package,
  Bell,
  ListStar,
  PlayCircle,
  PlusCircle,
  PuzzlePiece,
  Robot,
  Rocket,
  Star,
  Storefront,
  TextT,
  User,
  Users,
  UsersThree,
  type Icon,
} from '@phosphor-icons/react'

export const APP_ICONS = {
  // Navigation / core
  house: House,
  users: Users,
  intersect: Intersect,
  coins: Coins,
  gift: Gift,
  'credit-card': CreditCard,
  check: Check,
  crown: Crown,

  // Allegro modules
  clipboard: Clipboard,
  package: Package,
  'puzzle-piece': PuzzlePiece,
  'git-fork': GitFork,
  'text-t': TextT,
  image: Image,
  'file-text': FileText,
  gear: Gear,
  bell: Bell,
  star: Star,
  'list-star': ListStar,
  'chart-line': ChartLine,

  // Admin sidebar
  'chart-bar': ChartBar,
  user: User,
  'users-three': UsersThree,
  robot: Robot,

  // Promo
  rocket: Rocket,
  buildings: Buildings,
  lightbulb: Lightbulb,
  'plus-circle': PlusCircle,

  // School / tutorials
  'graduation-cap': GraduationCap,
  'play-circle': PlayCircle,

  // Feedback
  megaphone: MegaphoneSimple,
  'bug-beetle': BugBeetle,

  // Marketplace group headers (Circle + iconClassName for color)
  'marketplace-allegro': Circle,
  'marketplace-decathlon': Circle,
  'marketplace-castorama': Circle,
  'marketplace-leroymerlin': Circle,
  'marketplace-emag': Circle,
  'marketplace-general': Gear,
  'marketplace-storefront': Storefront,
} as const satisfies Record<string, Icon>

export type AppIconName = keyof typeof APP_ICONS

/** Tailwind color classes for marketplace dot icons */
export const MARKETPLACE_ICON_CLASS: Partial<Record<AppIconName, string>> = {
  'marketplace-allegro': 'text-orange-500',
  'marketplace-decathlon': 'text-blue-500',
  'marketplace-castorama': 'text-yellow-500',
  'marketplace-leroymerlin': 'text-green-500',
  'marketplace-emag': 'text-purple-500',
  'marketplace-general': 'text-gray-400',
}
